import React from 'react'
import packageJson from '../../package.json'

globalThis.appVersion = packageJson.version

const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g)
  const versionsB = versionB.split(/\./g)

  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift())
    const b = Number(versionsB.shift())

    if (a === b) continue
    return a > b || Number.isNaN(b)
  }

  return false
}

class CacheBuster extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        console.log('Clearing cache and hard reloading...')
        if (globalThis.caches) {
          globalThis.caches.keys().then((names) => {
            for (const name of names) globalThis.caches.delete(name)
          })
        }

        window.location.reload(true)
      }
    }
  }

  componentDidMount() {
    fetch(`/meta.json?nocache=${new Date().getTime()}`)
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version
        const currentVersion = globalThis.appVersion

        const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion)
        if (shouldForceRefresh) {
          console.log(`We have a new version - ${latestVersion}. Should force refresh`)
          this.setState({ loading: false, isLatestVersion: false })
        } else {
          console.log(
            `You already have the latest version - ${latestVersion}. No cache refresh needed.`
          )
          this.setState({ loading: false, isLatestVersion: true })
        }
      })
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state
    return this.props.children({ loading, isLatestVersion, refreshCacheAndReload })
  }
}

export default CacheBuster
